"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var LineageCartoucheStyles_1 = require("../../style/LineageCartoucheStyles");
var StyleFunctions_1 = require("../../style/StyleFunctions");
var HoverComponent_1 = require("../widgets/HoverComponent");
var LineageItemType_1 = require("./LineageItemType");
// Renders a clickable link icon for the Lineage Nav
var LineageIconButton = /** @class */ (function (_super) {
    __extends(LineageIconButton, _super);
    function LineageIconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineageIconButton.prototype.render = function () {
        var iconClasses = this.props.isCurrentPane ? StyleFunctions_1.classes(LineageCartoucheStyles_1.cartoucheIconStyle, LineageCartoucheStyles_1.activeLineageItemType) : LineageCartoucheStyles_1.cartoucheIconStyle;
        var NormalIcon = LineageItemType_1.getIconForContentType(this.props.lineageItemType, this.props.isCurrentPane ? LineageItemType_1.IconType.white : LineageItemType_1.IconType.inactive);
        var HoverIcon = LineageItemType_1.getIconForContentType(this.props.lineageItemType, this.props.isCurrentPane ? LineageItemType_1.IconType.white : LineageItemType_1.IconType.active);
        return (React.createElement(react_router_dom_1.Link, { to: this.props.linkHref, className: this.props.inCartouche ? LineageCartoucheStyles_1.cartoucheIconButtonClass : LineageCartoucheStyles_1.lineageIconButtonClass },
            React.createElement(HoverComponent_1.HoverComponent, { normalElement: React.createElement(NormalIcon, { className: iconClasses }), hoverElement: React.createElement(HoverIcon, { className: iconClasses }), altText: this.props.buttonAltText })));
    };
    return LineageIconButton;
}(React.Component));
exports.LineageIconButton = LineageIconButton;
//# sourceMappingURL=LineageIconButton.js.map